<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
              <span slot="tab">
                Incapacidades
              </span>
          <a-card>
            <g-master name="forms"
                      :endpoint="master.endpoint"
                      :tableSetup="master.tableSetup"
                      :modalFieldsSetup="master.modalFieldsSetup"
                      :parentData="parentData"
                      :beforeSend="master.beforeSend"
                      :actions="false"
                      ref="master"
                      @params="paramsTable"
            >
              <template slot="customButton">
                <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
              </template>
              <div slot="prorrogaRender" slot-scope="{record, text}" style="text-align: right;">
                <span v-if="record.prorroga_id !== null">SI</span>
              </div>
              <template slot="masterModal" slot-scope="{record}">
                <a-row :gutter="[16,16]">
                </a-row>
              </template>
            </g-master>
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
              <span slot="tab">
                SST
              </span>
          <absen-sst v-if="idAbsen" :abs_id="idAbsen"></absen-sst>
          <span v-else>Seleccione una incapacidad para ver más.</span>
        </a-tab-pane>
        <a-tab-pane key="2">
              <span slot="tab">
                Seguimientos HSEQ
              </span>
          <seguimiento-hseq v-if="idAbsen" :abs_id="idAbsen"></seguimiento-hseq>
          <span v-else>Seleccione una incapacidad para ver más.</span>
        </a-tab-pane>
        <a-tab-pane key="3">
              <span slot="tab">
                Seguimientos bienestar social
              </span>
          <seguimiento-bienestar-social v-if="idAbsen" :abs_id="idAbsen"></seguimiento-bienestar-social>
          <span v-else>Seleccione una incapacidad para ver más.</span>
        </a-tab-pane>
        <a-tab-pane key="4">
              <span slot="tab">
                Seguimientos jurídicos
              </span>
          <seguimiento-juridico v-if="idAbsen" :abs_id="idAbsen"></seguimiento-juridico>
          <span v-else>Seleccione una incapacidad para ver más.</span>
        </a-tab-pane>
        <a-tab-pane key="5">
              <span slot="tab">
                Seguimientos control interno
              </span>
          <seguimiento-control-interno v-if="idAbsen" :abs_id="idAbsen"></seguimiento-control-interno>
          <span v-else>Seleccione una incapacidad para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fileNameExcel: 'Incapacidades',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        paramsT: {},
        endpointExcel: 'ausentismo/downloadExcel',
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'absen',
          tableSetup: {
            customSlots: ['prorrogaRender'],
            allowSelect: true,
            selectedRows: [],
            actions: false,
            tableConfig: {
              rowKey: 'abs_id'
            },
            columns: [
              {title: 'ID Ausentismo', dataIndex: 'abs_id', sorter: true},
              {title: 'Tipo de ausentismo', dataIndex: 'tipo_abs', sorter: true},
              {title: 'Días de ausentismo', dataIndex: 'abs_days_desc', sorter: true},
              {title: 'Inicio del ausentismo', dataIndex: 'abs_inicial', sorter: true},
              {title: 'Fin del ausentismo', dataIndex: 'abs_final', sorter: true},
              {
                title: 'Es prórroga',
                dataIndex: 'prorroga_id',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'prorrogaRender'
                }
              },
              {
                title: 'Prórroga',
                dataIndex: 'prorroga_id',
                sorter: true
              },
              {title: 'Cod. diagnóstico', dataIndex: 'id_diag', sorter: true},
              {title: 'Diagnóstico', dataIndex: 'diag_desc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      idAbsen () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].abs_id : null
      },
      paramsExcel () {
        return {...this.paramsT, id_emp: this.empleadoseleccionado, incapacidades_hseq: true}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/Incapacidades.vue